import { WidgetData } from '@playbooks/core/src/interfaces'

import { BaseNode } from '../../'

export class WidgetNode<T extends WidgetData = WidgetData> extends BaseNode<T> {
  public get autoLaunch(): boolean {
    return this.data.autoLaunch || false
  }
}
